import React, { useState } from 'react';

const StarRating = ({ rating, id, handleInput, hover, handleHover }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isSelected, setIsSelected] = useState(false);

  return (
    <div id='star-rating'>
      {[...Array(5)].map((star, index) => {
        index += 1;
        return (
          <button
            type='button'
            key={index}
            className={index <= (rating || hover) ? 'on star_rating_button' : 'off star_rating_button'}
            onClick={() => {
              handleInput(index, id, 'star');
              setIsSelected(true);
            }}
            onMouseEnter={() => {
              handleHover(index);
              setIsHovered(true);
            }}
            onMouseLeave={() => {
              handleHover(rating);
              setIsHovered(false);
            }}
            aria-current={index <= (rating || hover) && (isSelected || isHovered) ? 'true' : 'false'}
          >
            <span className='star'>&#9733;</span>
          </button>
        );
      })}
    </div>
  );
};

export default StarRating;
